import WarningAmberIcon from "@mui/icons-material/WarningAmber";
import { Alert, AlertTitle, Box, Typography } from "@mui/material";
import { useContext } from "react";
import useColors from "../api/hooks/useColors";
import { BootstrapContext } from "../contexts/BootstrapContext";

const MSSPAdminWarningBanner = () => {
  const colors = useColors();
  const { MSSPWarningForBreeze, isLoading } = useContext(BootstrapContext);

  if (isLoading || !MSSPWarningForBreeze?.show_warning) {
    return null;
  }

  return (
    <Alert
      severity="warning"
      sx={{
        mb: 2,
        backgroundColor: colors.warning_orange_soft,
        borderColor: colors.warning_light_orange,
        borderWidth: "2px",
        borderStyle: "solid",
        borderRadius: "8px",
        "& .MuiAlert-icon": {
          color: colors.warning_darker,
        },
      }}
      icon={<WarningAmberIcon />}
    >
      <AlertTitle
        sx={{
          margin: 0,
          color: colors.warning_darker,
          fontWeight: "bold",
        }}
      >
        MSSP Admin Mode - Production Environment
      </AlertTitle>
      <Box sx={{ mt: 1 }}>
        <Typography
          variant="body2"
          sx={{
            color: colors.warning_darker,
            fontWeight: "500",
          }}
        >
          You are currently running with <strong>MSSP Admin privileges</strong>{" "}
          in a <strong>non-development AWS environment</strong> (Account:{" "}
          {MSSPWarningForBreeze.current_account_id}).
        </Typography>
        <Typography
          variant="body2"
          sx={{
            color: colors.warning_darker,
            mt: 0.5,
          }}
        >
          Please exercise extra caution when performing actions as they may
          affect customers.
        </Typography>
      </Box>
    </Alert>
  );
};

export default MSSPAdminWarningBanner;
